module.exports = __webpack_public_path__ + "img/Jamilya Kamalova.c42a68cc.jpg";